











import { Component, Prop } from "vue-property-decorator";

import { pathToLanguageID } from "../domain";
import Language from "./Language.vue";
import Loading from "./Loading.vue";

@Component({ components: { Language, Loading } })
export default class extends Language {
  @Prop(String)
  private id: string;

  private get highlighted(): boolean {
    return this.id === pathToLanguageID(this.$route.path);
  }

  private get loading(): boolean {
    const language = this.$store.state.languages[this.id];
    return language && language.loading;
  }

  private get path(): string {
    return "/" + encodeURIComponent(this.id);
  }

  private viewLanguage(): void {
    this.$store.commit("viewLanguage", this.id);
    this.$store.commit("toggleMenu");
  }
}
